<template>
  <div id="tratamentos-tipos">
    <custom-lista
      v-if="!carregando"
      class="tratamento-tipos-lista"
      :titulo="titulo"
      :fixa="fixa"
      :itens="itensRef"
      :colunas="Number.toString(itensRef.length)"
      width="300"
      height="auto"
    />
  </div>
</template>

<script setup>
const { t, locale } = useI18n();
const carregando = ref(true);
const fixa = ref(true);
const props = defineProps({ tratamento: String });
const titulo = t("Tipos de tratamento");

const { data: tipos } = await useFetch(
  `/api/site/tratamentos/${props.tratamento}/tipos`,
  { headers: { "Content-Language": locale } }
);
let itensRef = ref([]);

onMounted(() => {
  Object.values(tipos.value).forEach((item) => {
    itensRef.value.push({
      imagem: item.imagem,
      titulo: item.nome,
      texto: item.descricao,
      class: "tratamento-tipos-cartao",
    });
  });
  carregando.value = !itensRef.value.length > 0;
});
</script>

<script>
export default {
  name: "TratamentosTipos",
};
</script>
